import { CommonModule, DatePipe } from '@angular/common';
import { HttpErrorResponse } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { KeycloakService } from 'keycloak-angular';
import { KeycloakProfile } from 'keycloak-js';
import { MessageService } from 'primeng/api';
import { catchError, map, of, Subject, takeUntil } from 'rxjs';
import { collabDto } from 'src/app/models/collabDto';
import { entite } from 'src/app/models/entite';
import { Ope } from 'src/app/models/Ope';
import { userProfilDto } from 'src/app/models/userProfilDto';
import { EtageService } from 'src/app/services/bi/etage/etage.service';
import { collabService } from 'src/app/services/collab/collabService.service';
import { DepartementService } from 'src/app/services/departement/departement.service';
import { EntitebackService } from 'src/app/services/entite/entiteback.service';
import { OpeService } from 'src/app/services/ope/ope.service';
import { sharePitSevices } from 'src/app/services/pitupload/sharePit.service';
import { RegionService } from 'src/app/services/region/region.service';
import { shareOpeSevices } from 'src/app/services/sharedservices/shareOpe.services';
import { SidebarService } from 'src/app/services/sideBare.service';
import { StatutLotService } from 'src/app/services/statutLot/statut-lot.service';
import { TvaLotService } from 'src/app/services/tvaLot/tva-lot.service';
import { TypeLotService } from 'src/app/services/typeLot/type-lot.service';
import { TypologieLotService } from 'src/app/services/typologieLot/typologie-lot.service';
import { VilleService } from 'src/app/services/ville/ville.service';
import { PituploadService } from 'src/app/services/pitupload/pitupload.service';
import { SearchPitOpeCriteria } from 'src/app/models/SearchPitOpeCriteria';
import { OpePit } from 'src/app/models/OpePit';
import { ProgressBarModule } from 'primeng/progressbar';
import { TableModule } from 'primeng/table';
import { CheckboxModule } from 'primeng/checkbox';
import { ToastModule } from 'primeng/toast';
import { PaginatorModule } from 'primeng/paginator';
import { FormsModule } from '@angular/forms';
import { ButtonModule } from 'primeng/button';

@Component({
  selector: 'app-page-pitupload',
  templateUrl: './page-pitupload.component.html',
  imports: [ProgressBarModule,TableModule,CheckboxModule,CommonModule,ToastModule,PaginatorModule,FormsModule,ButtonModule],
  styleUrls: ['./page-pitupload.component.scss'],
  providers: [DatePipe, MessageService]

})
export class PagePituploadComponent implements OnInit {

  private _destroy$: Subject<void> = new Subject();
  error: any;
  userRole!: string[];

  userprofilshare: userProfilDto = {
    nom: '',
    prenom: '',
    role: [],
    enable: true,
    mail: ''

  };
  public profile?: KeycloakProfile;
  entitylib = "";
  idvendeurwincom = "";
  collabRole = "";
  newContactInsert = false;
  searchPitCrit!: SearchPitOpeCriteria;
  listope: OpePit[] = [];
  numOpe: number | null = null;
  numOpeExt: string | null = null;
  libOpe: string | null = null;
  depOpe: string | null = null;
  villeOpe: string | null = null;
  paginatorTotalPages: number = 0;
  paginatorPage: number = 0;
  paginatorFirst: number = 0;
  paginatorLast: number = 0;
  paginatorRows: number = 10;
  paginatorTotalRecords: number = 0;
  programmeToShare!: Ope;


  constructor(public pitService: PituploadService, public messageService: MessageService, public datePipe: DatePipe, private keycloakService: KeycloakService, private collabService: collabService, private entityback: EntitebackService, private opeservice: OpeService, private _sidebar: SidebarService, public sharedCritereSerice: shareOpeSevices, private regionService: RegionService, private departementService: DepartementService,
    private villeService: VilleService, private typeLotService: TypeLotService, private typologieLotService: TypologieLotService,
    private etageService: EtageService, private statutLotService: StatutLotService, private tvaLotService: TvaLotService, private router: Router, public share: shareOpeSevices, public sharePitSevices: sharePitSevices) {

    this.searchPitCrit = new SearchPitOpeCriteria();
  }

  ngOnInit() {


    this.share.showprogressbar = true;

    this.keycloakService.loadUserProfile().then(

      profile => {

        this.profile = profile;

        this.userprofilshare.prenom = this.profile.firstName;
        this.userprofilshare.nom = this.profile.lastName;
        this.userprofilshare.mail = this.profile.email;
        // console.log(profile);
        this.userprofilshare.enable = this.profile.enabled;
        this.userprofilshare.role = this.keycloakService.getUserRoles();
        this.userRole = this.userprofilshare.role;
        if (!this.hasRole("pit")) {
          this.router.navigate([`/accueil`]);
        }
        else {
          this.collabService.getCollabByEmail(this.profile.email).pipe(map((collab: collabDto) => {
            this.collabRole = (collab.profil === "1") ? "admin" : (collab.profil === "2") ? "interne" : "externe";
            this.idvendeurwincom = collab.numPrimpromo;
            this.sharePitSevices.user = this.idvendeurwincom;
            this.entityback.getEntitebyId(eval(collab.numEntite)).pipe(map((data: entite) => {
              this.entitylib = data.libelle;
              this.share.showprogressbar = false;
            }), catchError(this.handleError), takeUntil(this._destroy$)).subscribe();
          }), catchError(this.handleError), takeUntil(this._destroy$)).subscribe();


          this.recherche(null)
        }


      });
  }

  hasRole(role: string): boolean {

    if (this.userRole && this.userRole.length > 0) {
      return this.userRole.includes(role);
    }
    return false;
  }

  handleError = (error: HttpErrorResponse) => {

    this.error = error.message;

    if (this.share.showprogressbar == true) {
      this.share.showprogressbar = false;

    }
    return of(error.message);
  };

  motCle = "";

  recherche(montag: any) {
    this.share.showprogressbar = true;
    this.searchPitCrit.nom = this.libOpe!;
    this.searchPitCrit.numOpe = this.numOpe!;
    this.searchPitCrit.numOpeExt = this.numOpeExt!;
    this.searchPitCrit.ville = this.villeOpe!;
    this.searchPitCrit.codePostal

    this.pitService.getOpebyCriteria(this.searchPitCrit, "pit", this.paginatorPage, this.paginatorRows)
      .subscribe({
        next: (data: any) => {
          this.listope.length = 0;
          this.listope = data.content;
          if (this.share.showprogressbar == true) {
            this.share.showprogressbar = false;
          };
          this.paginatorTotalRecords = data.totalElements;
          this.paginatorTotalPages = data.totalPages;
          this.paginatorFirst = data.pageable.offset;
          this.paginatorLast = this.paginatorFirst + data.numberOfElements;
        },
        error: (err) => {
          this.messageService.add({ severity: 'error', summary: "Erreur " + err.status, detail: err.message });
        },
        complete: () => {
          this.sharePitSevices.pituploadlistope = this.listope;
          this.share.showprogressbar = false;
        }

      })
  };

  initSearchCrit() {
    this.libOpe = null;
    this.numOpe = null;
    this.numOpeExt = null;
    this.depOpe = null;
    this.villeOpe = null;
    // console.log(this.searchPitCrit);
  }

  removeDuplicates(myArray: any[], Prop: string) {

    return myArray.filter((obj: any, pos: number, arr: any[]) => {
      return arr.map((mapObj: any) => mapObj[Prop as keyof typeof mapObj]).indexOf(obj[Prop as keyof typeof obj]) === pos;
    });
  }



  selectOpe(ope: OpePit) {
    this.sharePitSevices.pituploadSelectedOpe = ope;
    this.programmeToShare = {
      numOpe: ope.numOpe,
      numOpeExt: ope.numOpeExt,
      nom: ope.nom ? ope.nom : "",
      adresse1: ope.adresse1,
      adresse2: ope.adresse2,
      adresse3: ope.adresse3,
      codePostal: ope.codePostal,
      ville: ope.ville,
      codePays: "",
      disponibles: 0,
      optionnes: 0,
      totalLots: 0,
      dateLivraison: null,
      minStatutLot: "",
      maxStatutLot: "",
      prixMin: 0,
      minTypeLot: "",
      maxTypeLot: "",
      visiteVirtuelle: "",
      tab: "",
      extranet: true,
      web: false
    };
    this.sharePitSevices.sendSelectedOpee(this.programmeToShare);
    this.router.navigate([`/page-programme-piupload`]);
  }

  onchangeOpeExt(ope: OpePit) {
    this.share.showprogressbar = true;
    let msgNotif = "Publication Extranet activée";
    let severity = "success";
    if (ope.pubExt !== 1) ope.pubExt = 1;
    else {
      ope.pubExt = 0;
      severity = "success";
      msgNotif = "Publication Extranet désactivée";
    }
    this.pitService.updatePubPit(ope)
      .subscribe({
        next: (data: OpePit) => {
          this.messageService.add({ severity: severity, summary: "Modification de l'opération " + ope.numOpe, detail: msgNotif });
          console.log(data);
          this.recherche(null);
        },
        error: (err) => {
          this.messageService.add({ severity: 'error', summary: "Erreur " + err.status, detail: err.message });
        },
        complete: () => {
          this.share.showprogressbar = false;
        }
      })
  }

  onchangeOpeWeb(ope: OpePit) {
    this.share.showprogressbar = true;
    let msgNotif = "Publication Web activée";
    let severity = "success";
    if (ope.publication !== 1) ope.publication = 1;
    else {
      ope.publication = 0;
      severity = "success";
      msgNotif = "Publication Web désactivée";
    }
    this.pitService.updatePubPit(ope)
      .subscribe({
        next: (data: OpePit) => {
          this.messageService.add({ severity: severity, summary: "Modification de l'opération " + ope.numOpe, detail: msgNotif });
          //console.log(data);
          this.recherche(null);
        },
        error: (err) => {
          this.messageService.add({ severity: 'error', summary: "Erreur " + err.status, detail: err.message });
        },
        complete: () => {
          this.share.showprogressbar = false;
        }
      })
  }

  formatDateFromString(date: string) {
    let dateFrm = this.datePipe.transform(Date.parse(date), 'dd/MM/yyyy')?.toString();
    return dateFrm;
  }

  onPageChange(event: any) {
    this.paginatorPage = event.page;
    this.recherche(null);
  }
}
